import { render, staticRenderFns } from "./SingleResultDetails.vue?vue&type=template&id=280c16c6&scoped=true&"
import script from "./SingleResultDetails.vue?vue&type=script&lang=js&"
export * from "./SingleResultDetails.vue?vue&type=script&lang=js&"
import style0 from "./SingleResultDetails.vue?vue&type=style&index=0&id=280c16c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c16c6",
  null
  
)

export default component.exports